import React from "react";
import { Truck, RotateCcw, ShieldCheck, Globe } from "lucide-react";
import PageHero from "@/components/PageHero";
import Breadcrumb from "@/components/Breadcrumb";
import NewsletterSection from "@/components/NewsletterSection";
import useReveal from "@/hooks/useReveal";

const ITEMS = [
  { icon: Truck, title: "Délais & frais", desc: "Préparation sous 24–48h, livraison en 2–4 jours ouvrés. Livraison offerte dès 45€, sinon 4,90€." },
  { icon: Globe, title: "Zones desservies", desc: "Belgique et France. D'autres pays européens seront bientôt disponibles." },
  { icon: RotateCcw, title: "Retours gratuits", desc: "30 jours pour changer d'avis. Retour gratuit, produit ouvert ou non, remboursement intégral." },
  { icon: ShieldCheck, title: "Suivi & sécurité", desc: "Numéro de suivi envoyé par email. Paiement 100% sécurisé via Stripe." },
];

export default function Livraison() {
  useReveal([]);
  return (
    <>
      <PageHero tag="Service client" title="Livraison &amp; <em>Retours</em>" subtitle="Une expérience simple, transparente et sans risque, jusque chez vous." />
      <Breadcrumb trail={[{ label: "Accueil", to: "/" }, { label: "Livraison & retours" }]} />

      <section className="products-section reveal">
        <div className="feature-grid" style={{ gridTemplateColumns: "repeat(2, 1fr)", maxWidth: 900 }}>
          {ITEMS.map((it) => {
            const Icon = it.icon;
            return (
              <div className="feature-card" key={it.title}>
                <Icon size={28} color="var(--gold)" strokeWidth={1.5} />
                <h3>{it.title}</h3>
                <p>{it.desc}</p>
              </div>
            );
          })}
        </div>
      </section>

      <NewsletterSection />
    </>
  );
}
